interface SpacerProps {
    size?: 'small' | 'medium' | 'large' | 'xl' | 'xxl';
    direction?: 'horizontal' | 'vertical';
}

const sizes = {
    small: '8px',
    medium: '16px',
    large: '24px',
    xl: '32px',
    xxl: '40px',
};

export const Spacer = ({ size = 'medium', direction = 'vertical' }: SpacerProps) => (
    <div
        style={{
            width: direction === 'horizontal' ? sizes[size] : '100%',
            height: direction === 'vertical' ? sizes[size] : '100%',
        }}
    />
);
